module.exports = __webpack_public_path__ + "static/img/7.ee686dc3.png";